// extracted by mini-css-extract-plugin
export default {"actionButtonStyle":"ChangeVatNumberCard_actionButtonStyle__h--w3","form":"ChangeVatNumberCard_form__gJ6rv","gridContainer":"ChangeVatNumberCard_gridContainer__naTLO"};